import { css } from 'styled-components';
import { renderStyle } from 'web-app/styleguide/render-style';
/** Matter Bold */
const MatterBoldWoff2 = require('root/public/fonts/Matter/Matter-Bold.woff2');
const MatterBoldWoff = require('root/public/fonts/Matter/Matter-Bold.woff');
/** Matter Bold Italic */
const MatterBoldItalicWoff2 = require('root/public/fonts/Matter/Matter-BoldItalic.woff2');
const MatterBoldItalicWoff = require('root/public/fonts/Matter/Matter-BoldItalic.woff');
/** Matter Semi Bold */
const MatterSemiBoldWoff2 = require('root/public/fonts/Matter/Matter-SemiBold.woff2');
const MatterSemiBoldWoff = require('root/public/fonts/Matter/Matter-SemiBold.woff');
/** Matter Semi Bold */
const MatterMediumItalicWoff2 = require('root/public/fonts/Matter/Matter-MediumItalic.woff2');
const MatterMediumItalicWoff = require('root/public/fonts/Matter/Matter-MediumItalic.woff');
/** Matter Heavy */
const MatterHeavyWoff2 = require('root/public/fonts/Matter/Matter-Heavy.woff2');
const MatterHeavyWoff = require('root/public/fonts/Matter/Matter-Heavy.woff');
/** Matter Light Italic */
const MatterLightItalicWoff2 = require('root/public/fonts/Matter/Matter-LightItalic.woff2');
const MatterLightItalicWoff = require('root/public/fonts/Matter/Matter-LightItalic.woff');
/** Matter Medium */
const MatterMediumWoff2 = require('root/public/fonts/Matter/Matter-Medium.woff2');
const MatterMediumWoff = require('root/public/fonts/Matter/Matter-Medium.woff');
/** Matter Semi Bold Italic */
const MatterSemiBoldItalicWoff2 = require('root/public/fonts/Matter/Matter-SemiBoldItalic.woff2');
const MatterSemiBoldItalicWoff = require('root/public/fonts/Matter/Matter-SemiBoldItalic.woff');
/** Matter Heavy Italic */
const MatterHeavyItalicWoff2 = require('root/public/fonts/Matter/Matter-HeavyItalic.woff2');
const MatterHeavyItalicWoff = require('root/public/fonts/Matter/Matter-HeavyItalic.woff');
/** Matter Heavy Italic */
const MatterLightWoff2 = require('root/public/fonts/Matter/Matter-Light.woff2');
const MatterLightWoff = require('root/public/fonts/Matter/Matter-Light.woff');
/** Matter Regular */
const MatterRegularWoff2 = require('root/public/fonts/Matter/Matter-Regular.woff2');
const MatterRegularWoff = require('root/public/fonts/Matter/Matter-Regular.woff');
/** Matter Regular Italic */
const MatterRegularItalicWoff2 = require('root/public/fonts/Matter/Matter-RegularItalic.woff2');
const MatterRegularItalicWoff = require('root/public/fonts/Matter/Matter-RegularItalic.woff');
/** Inter Regular */
const InterRegularWoff2 = require('root/public/fonts/Inter/Inter-Regular.woff2');
/** Inter Medium */
const InterMediumWoff2 = require('root/public/fonts/Inter/Inter-Medium.woff2');
/** Inter SemiBold */
const InterSemiBoldWoff2 = require('root/public/fonts/Inter/Inter-SemiBold.woff2');
/** Material Symbols
 *
 * update the `v` parameter for it in the `font-face` declaration below
 * when you update the font file
 */
const MaterialSymbols = require('root/public/fonts/Material-Symbols/Material-Symbols-Rounded-Wght-300.woff2');
export const MFFonts = renderStyle(css `
    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Bold'),
            local('Matter-Bold'),
            url('${MatterBoldWoff2}') format('woff2'),
            url('${MatterBoldWoff}') format('woff');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }
    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Bold Italic'),
            local('Matter-BoldItalic'),
            url('${MatterBoldItalicWoff2}') format('woff2'),
            url('${MatterBoldItalicWoff}') format('woff');
        font-weight: bold;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter SemiBold'),
            local('Matter-SemiBold'),
            url('${MatterSemiBoldWoff2}') format('woff2'),
            url('${MatterSemiBoldWoff}') format('woff');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Medium Italic'),
            local('Matter-MediumItalic'),
            url('${MatterMediumItalicWoff2}') format('woff2'),
            url('${MatterMediumItalicWoff}') format('woff');
        font-weight: 500;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Heavy'),
            local('Matter-Heavy'),
            url('${MatterHeavyWoff2}') format('woff2'),
            url('${MatterHeavyWoff}') format('woff');
        font-weight: 900;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Light Italic'),
            local('Matter-LightItalic'),
            url('${MatterLightItalicWoff2}') format('woff2'),
            url('${MatterLightItalicWoff}') format('woff');
        font-weight: 300;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Medium'),
            local('Matter-Medium'),
            url('${MatterMediumWoff2}') format('woff2'),
            url('${MatterMediumWoff}') format('woff');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter SemiBold Italic'),
            local('Matter-SemiBoldItalic'),
            url('${MatterSemiBoldItalicWoff2}') format('woff2'),
            url('${MatterSemiBoldItalicWoff}') format('woff');
        font-weight: 600;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Heavy Italic'),
            local('Matter-HeavyItalic'),
            url('${MatterHeavyItalicWoff2}') format('woff2'),
            url('${MatterHeavyItalicWoff}') format('woff');
        font-weight: 900;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Light'),
            local('Matter-Light'),
            url('${MatterLightWoff2}') format('woff2'),
            url('${MatterLightWoff}') format('woff');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Regular'),
            local('Matter-Regular'),
            url('${MatterRegularWoff2}') format('woff2'),
            url('${MatterRegularWoff}') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Matter';
        src:
            local('Matter Regular Italic'),
            local('Matter-RegularItalic'),
            url('${MatterRegularItalicWoff2}') format('woff2'),
            url('${MatterRegularItalicWoff}') format('woff');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
        font-synthesis: none;
    }

    @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${InterRegularWoff2}') format('woff2');
    }

    @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('${InterMediumWoff2}') format('woff2');
    }

    @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url('${InterSemiBoldWoff2}') format('woff2');
    }

    /* Material Symbols Rounded, weight 300, optical size 24, grade 0, fill 0..1 */
    @font-face {
        font-family: 'Material Symbols Rounded';
        font-style: normal;
        src: url('${MaterialSymbols}?v=3') format('woff2');
    }
`);
